import { createTheme } from "@mui/material";

declare module '@mui/material/styles' {
  interface TypeBackground {
    color?: string;
  }
}

declare module '@mui/material/styles' {
  interface Palette {
    priority: {
      high: string;
      critical: string;
      low: string;
      medium: string;
    };
    priorityBorder: {
      high: string;
      critical: string;
      low: string;
      medium: string;
    };
    divider: string;
    tableBorder: string;
    borderFocus: string;
    button: {
      main: string;
      primary: string;
      color: string;
      secondary: string;
      borderColor: string;
      errorBackground: string;
    };
    customBorder: {
      bottom: string,
      up: string,
      left: string,
      right: string,
      all: string,
      node: string
    };
    customStatus: {
      success: string;
      successLight: string;
      inprogress: string;
      inprogressLight: string,
      error: string;
      errorLight: string;
    }
    backgroundColor?: string,
    cardBackgroundColor?: string,
    textColor?: string,
    progressBar: {
      progress: string;
      track: string;
    }
    accent: {
      purple: string,
    },
    rolePersonaChips: {
      endUser: {
        accent: string;
        text: string;
      };
      transition: {
        accent: string;
        text: string;
      };
      fallback: {
        accent: string;
        text: string;
      };
    };
    chart: {
      colors: string[];
      multiPeriodColors: string[];
      slider: {
        primary: string;
        thumb: string;
        track: string;
      };
      bars: {
        primary: string;
        secondary: string;
      };
      pieChart: {
        titleColor: string;
        labelColor: string;
        backgroundColor: string;
        borderColor: string;
        segmentColors: string[];
        impactColors: {
          '1': string;
          '2': string;
          '3': string;
        };
      };
      incidentsChart: {
        incidentAreaColor: string;
        highIncidentMarker: string;
        axisTextColor: string;
        gridColor: string;
        backgroundColor: string;
        borderColor: string;
      };
    };
    iconBackground: {
      card: string;
    };
    header: {
      background: string;
      darker: string;
    };
    nodeColors: {
      root: { backgroundColor: string; color: string; };
      category: { backgroundColor: string; color: string; };
      issue: { backgroundColor: string; color: string; };
      count: { backgroundColor: string; color: string; };
    };
    highlight: {
      lightBlue: string;
      darkBlue: string;
      mediumBlue: string;
      green: string;
      white: string;
    };
    hotspot: {
      red: string;
      orange: string;
      green: string;
      gray: string;
    };
    markdown: {
      textColor: string;
    };
    pdfExport: {
      titleColor: string;
      timestampColor: string;
      backgroundColor: string;
    };
    ticketStatus: {
      open: string;
      closed: string;
      pending: string;
      default: string;
    };
    latency: {
      veryFast: string;
      fast: string;
      medium: string;
      slow: string;
      verySlow: string;
    };
    graph: {
      nodes: {
        start: {
          background: string;
          border: string;
          text: string;
          shadow: string;
        };
        end: {
          background: string;
          border: string;
          text: string;
          shadow: string;
        };
        process: {
          background: string;
          border: string;
          text: string;
          shadow: string;
        };
        selected: {
          background: string;
          border: string;
          text: string;
          shadow: string;
        };
      };
      edges: {
        default: string;
        highlighted: string;
      };
      canvas: {
        light: string;
        dark: string;
      };
    };
  }
  interface PaletteOptions {
    priority?: {
      high: string;
      critical: string;
      low: string;
      medium: string;
    };
    priorityBorder?: {
      high: string;
      critical: string;
      low: string;
      medium: string;
    };
    divider?: string;
    tableBorder?: string;
    borderFocus?: string;
    button?: {
      main: string;
      primary: string;
      secondary: string;
      color: string;
      borderColor: string;
      errorBackground: string;
    };
    customBorder: {
      bottom: string,
      up: string,
      left: string,
      right: string,
      all: string,
      node: string
    },
    customStatus: {
      success: string;
      successLight: string;
      inprogress: string;
      inprogressLight: string,
      error: string;
      errorLight: string;
    }
    chatStyles?: {
      chatComponentBackground: string,
      future_prompt_background: string,
      userInputBackground: string,
      userInputText: string,
    },
    backgroundColor?: string,
    cardBackgroundColor?: string,
    textColor?: string,

    progressBar: {
      progress: string;
      track: string;
    }
    accent: {
      purple: string;
    };
    rolePersonaChips?: {
      endUser?: {
        accent: string;
        text: string;
      };
      transition?: {
        accent: string;
        text: string;
      };
      fallback?: {
        accent: string;
        text: string;
      };
    };
    chart?: {
      colors?: string[];
      multiPeriodColors?: string[];
      slider?: {
        primary: string;
        thumb: string;
        track: string;
      };
      bars?: {
        primary: string;
        secondary: string;
      };
      pieChart?: {
        titleColor: string;
        labelColor: string;
        backgroundColor: string;
        borderColor: string;
        segmentColors: string[];
        impactColors: {
          '1': string;
          '2': string;
          '3': string;
        };
      };
      incidentsChart?: {
        incidentAreaColor: string;
        highIncidentMarker: string;
        axisTextColor: string;
        gridColor: string;
        backgroundColor: string;
        borderColor: string;
      };
    };
    iconBackground: {
      card: string;
    };
    header?: {
      background: string;
      darker: string;
    };
    nodeColors?: {
      root: { backgroundColor: string; color: string; };
      category: { backgroundColor: string; color: string; };
      issue: { backgroundColor: string; color: string; };
      count: { backgroundColor: string; color: string; };
    };
    highlight?: {
      lightBlue: string;
      darkBlue: string;
      mediumBlue: string;
      green: string;
      white: string;
    };
    hotspot?: {
      red: string;
      orange: string;
      green: string;
      gray: string;
    };
    markdown?: {
      textColor: string;
    };
    pdfExport?: {
      titleColor: string;
      timestampColor: string;
      backgroundColor: string;
    };
    ticketStatus?: {
      open: string;
      closed: string;
      pending: string;
      default: string;
    };
    latency?: {
      veryFast: string;
      fast: string;
      medium: string;
      slow: string;
      verySlow: string;
    };
    graph?: {
      nodes?: {
        start?: {
          background: string;
          border: string;
          text: string;
          shadow: string;
        };
        end?: {
          background: string;
          border: string;
          text: string;
          shadow: string;
        };
        process?: {
          background: string;
          border: string;
          text: string;
          shadow: string;
        };
        selected?: {
          background: string;
          border: string;
          text: string;
          shadow: string;
        };
      };
      edges?: {
        default: string;
        highlighted: string;
      };
      canvas?: {
        light: string;
        dark: string;
      };
    };
  }
}

export const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#4282FE',
    },
    progressBar: {
      progress: '#4282FE',
      track: '#ECF3FF'
    },
    secondary: {
      main: '#f48fb1',
    },
    background: {
      paper: '#EEEEEE',
      color: '#FFFFFF',
      default: '#FCFCFD)',
    },
    action: {
      selected: '#ECF3FF'
    },
    text: {
      primary: '#101828',
      secondary: '#475467'
    },
    priority: {
      high: '#DE8D0D26',
      critical: '#E0416126',
      low: '#43AE7E26',
      medium: '#3F9BF626',
    },
    priorityBorder: {
      high: '#c99446',
      critical: '#E04161',
      low: '#769F59',
      medium: '#3F9BF6',
    },
    divider: '#FCFCFD',
    tableBorder: '#D0D0D0', 
    borderFocus: '#EEEEEE',
    button: {
      main: '#121212',
      primary: '#4282FE',
      secondary: '#fc4834',
      color: '#ffffff',
      borderColor: '#999999',
      errorBackground: '#E0416117',
    },
    customBorder: {
      bottom: '#121212',
      up: '#121212',
      left: '#121212',
      right: '#121212',
      all: '#e0e0e0',
      node: '#000000',
    },
    customStatus: {
      success: '#48bb78ff',
      successLight: '#48bb781f',
      inprogress: '#ffc107ff',
      inprogressLight: '#ffc1071',
      error: '#d32f2f',
      errorLight: '#d32f2f2c',
    },
    chatStyles: {
      chatComponentBackground: '#fcfcfd',
      future_prompt_background: '#f3f4f6',
      userInputBackground: '#c1bbc7ff',
      userInputText: '#080606ff',
    },
    accent: {
      purple: '#6B46ff',
    },
    rolePersonaChips: {
      endUser: {
        accent: '#2196F3',
        text: '#1565C0',
      },
      transition: {
        accent: '#7C4DFF',
        text: '#5E35B1',
      },
      fallback: {
        accent: '#78909C',
        text: '#455A64',
      },
    },
    chart: {
      colors: [
        '#0066CC', '#66B3FF', '#FF6B6B', '#FFB3B3', 
        '#4DB8A8', '#FFA726', '#FFD54F', '#9C27B0',
        '#E91E63', '#00BCD4', '#8BC34A', '#FF9800'
      ],
      multiPeriodColors: [
        '#1E88E5', '#26A69A', '#7E57C2', '#FF7043', '#EC407A',
        '#FFA726', '#66BB6A', '#5C6BC0', '#EF5350', '#26C6DA',
        '#AB47BC', '#9CCC65', '#FF6F00', '#78909C', '#D4E157'
      ],
      slider: {
        primary: '#9c27b0',
        thumb: '#9c27b0',
        track: '#9c27b0',
      },
      bars: {
        primary: '#8884d8',
        secondary: '#82ca9d',
      },
      pieChart: {
        titleColor: '#4A90E2',
        labelColor: '#666666',
        backgroundColor: '#fafafa',
        borderColor: '#e0e0e0',
        segmentColors: [
          '#5C53A5', '#A059A0', '#CE6693', '#F87082', '#FFAB83', 
          '#FFD084', '#F0F47A', '#B4E373', '#7DD8C7', '#7BB3F0'
        ],
        impactColors: {
          '1': '#CD6693',  // Impact level 1
          '2': '#A15AA0',  // Impact level 2  
          '3': '#5D53A4'   // Impact level 3
        }
      },
      incidentsChart: {
        incidentAreaColor: '#ff5252',
        highIncidentMarker: '#00bcd4',
        axisTextColor: '#666666',
        gridColor: '#e0e0e0',
        backgroundColor: '#fafafa',
        borderColor: '#e0e0e0',
      },
    },
    iconBackground: {
      card: '#EAF9FF',
    },
    header: {
      background: '#3498B3',
      darker: '#D0D0D0',
    },
    nodeColors: {
      root: { backgroundColor: '#B3D3F3', color: '#000000' },
      category: { backgroundColor: '#4D98E4', color: '#000000' },
      issue: { backgroundColor: '#73C6B6', color: '#000000' },
      count: { backgroundColor: '#F55D5D', color: '#000000' },
    },
    highlight: {
      lightBlue: '#E3F2FD',
      darkBlue: '#1976D2',
      mediumBlue: '#2196F3',
      green: '#4CAF50',
      white: '#FFFFFF',
    },
    hotspot: {
      red: '#F44336',
      orange: '#ff9800',
      green: '#48bb78ff',
      gray: '#757575',
    },
    markdown: {
      textColor: '#1565C0',
    },
    pdfExport: {
      titleColor: '#333333',
      timestampColor: '#666666',
      backgroundColor: '#ffffff',
    },
    ticketStatus: {
      open: '#FF9800',      // Orange
      closed: '#4CAF50',    // Green
      pending: '#2196F3',   // Blue
      default: '#9E9E9E',   // Grey
    },
    latency: {
      veryFast: '#4CAF50',  // < 1s - green
      fast: '#2196F3',      // < 5s - blue
      medium: '#FF9800',    // < 10s - orange
      slow: '#FF5722',      // < 20s - deep orange
      verySlow: '#F44336',  // >= 20s - red
    },
    graph: {
      nodes: {
        start: {
          background: '#4CAF50',
          border: '#2E7D32',
          text: '#FFFFFF',
          shadow: '#4CAF504D', // 30% opacity
        },
        end: {
          background: '#EF5350',
          border: '#C62828',
          text: '#FFFFFF',
          shadow: '#EF53504D', // 30% opacity
        },
        process: {
          background: '#F5F5F5',
          border: '#E0E0E0',
          text: '#101828',
          shadow: '#0000001A', // 10% opacity
        },
        selected: {
          background: '#2196F3',
          border: '#1565C0',
          text: '#FFFFFF',
          shadow: '#2196F366', // 40% opacity
        },
      },
      edges: {
        default: '#BDBDBD',
        highlighted: '#2196F3',
      },
      canvas: {
        light: '#FCFCFD',
        dark: '#151515',
      },
    },
    backgroundColor: '#f3f4f6',
    cardBackgroundColor: '#FCFCFC',
    textColor: '#080606ff',
  },
  typography: {
    allVariants: {
      fontFamily: "Proxima Nova, Arial, sans- serif"
    }
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: '#FCFCFC', // Dark background color for the entire page
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          backgroundImage: 'none',
          '&:before': {
            display: 'none',
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none', // or 'none', 'lowercase'
        },
      },
    },
  },
});

// export const darkTheme = createTheme({
//   palette: {
//     mode: 'dark',
//     primary: {
//       main: '#90caf9', // Dark primary color
//     },
//   },
//   components: {
//     MuiCssBaseline: {
//       styleOverrides: {
//         body: {
//           backgroundColor: '#151515', // Dark background color for the entire page
//         },
//       },
//     },
//   },
// });

export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#4282FE',
    },
    progressBar: {
      progress: '#4282FE',
      track: '#ECF3FF'
    },
    secondary: {
      main: '#f48fb1',
    },
    background: {
      paper: '#212325',
      color: '#FFFFFF',
      default: '#151515',
    },
    action: {
      selected: '#1b2b33'
    },
    text: {
      primary: '#E3E6EC',
      secondary: '#969A9E'
    },
    priority: {
      high: '#332b1e',
      critical: '#342228',
      low: '#222f2b',
      medium: '#222d38',
    },
    priorityBorder: {
      high: '#ff9800',
      critical: '#b71c1c',
      low: '#1b5e20',
      medium: '#0d47a1',
    },
    divider: '#404247',
    tableBorder: '#404247', // Table border color for dark theme
    borderFocus: '#404247',
    button: {
      main: '#121212',
      primary: '#4282FE',
      secondary: '#fc4834',
      color: '#ffffff',
      borderColor: '#999999',
      errorBackground: '#E0416117'
    },
    customBorder: {
      bottom: '#121212',
      up: '#121212',
      left: '#121212',
      right: '#121212',
      all: '#404247',
      node: '#000000',
    },
    customStatus: {
      success: '#48bb78ff',
      successLight: '#48bb781f',
      inprogress: '#ffc107ff',
      inprogressLight: '#ffc1071',
      error: '#d32f2f',
      errorLight: '#d32f2f2c',
    },
    chatStyles: {
      chatComponentBackground: '#1e1e1e',
      future_prompt_background: '#645c5cff',
      userInputBackground: '#4a4650ff',
      userInputText: '#E3E6EC',
    },
    accent: {
      purple: '#6B46ff',
    },
    rolePersonaChips: {
      endUser: {
        accent: '#64B5F6',
        text: '#90CAF9',
      },
      transition: {
        accent: '#B388FF',
        text: '#CE93D8',
      },
      fallback: {
        accent: '#90A4AE',
        text: '#B0BEC5',
      },
    },
    chart: {
      colors: [
        '#4A9EFF', '#8BC7FF', '#FF8E8E', '#FFD4D4',
        '#6ACFC0', '#FFB84D', '#FFE270', '#B858D0',
        '#FF4A85', '#33D4E8', '#A5D96C', '#FFB333'
      ],
      multiPeriodColors: [
        '#42A5F5', '#4DB6AC', '#9575CD', '#FF8A65', '#F06292',
        '#FFB74D', '#81C784', '#7986CB', '#E57373', '#4DD0E1',
        '#BA68C8', '#AED581', '#FFA726', '#90A4AE', '#DCE775'
      ],
      slider: {
        primary: '#B858D0',
        thumb: '#B858D0',
        track: '#B858D0',
      },
      bars: {
        primary: '#4A9EFF',
        secondary: '#6ACFC0',
      },
      pieChart: {
        titleColor: '#4A9EFF',
        labelColor: '#969A9E',
        backgroundColor: '#212325',
        borderColor: '#404247',
        segmentColors: [
          '#8A7DC9', '#BB7DB3', '#E699A8', '#FF9A98', '#FFC99F', 
          '#FFDF9F', '#F4F79D', '#C7ED8F', '#9EE5D7', '#9CC5F0'
        ],
        impactColors: {
          '1': '#CD6693',  // Impact level 1 (same colors for dark theme)
          '2': '#A15AA0',  // Impact level 2  
          '3': '#5D53A4'   // Impact level 3
        }
      },
      incidentsChart: {
        incidentAreaColor: '#FF8E8E',
        highIncidentMarker: '#33D4E8',
        axisTextColor: '#969A9E',
        gridColor: '#404247',
        backgroundColor: '#212325',
        borderColor: '#404247',
      },
    },
    iconBackground: {
      card: '#9FA9AD',
    },
    header: {
      background: '#3498B3',
      darker: '#2A2A2A',
    },
    nodeColors: {
      root: { backgroundColor: '#B3D3F3', color: '#000000' },
      category: { backgroundColor: '#4D98E4', color: '#000000' },
      issue: { backgroundColor: '#73C6B6', color: '#000000' },
      count: { backgroundColor: '#F55D5D', color: '#000000' },
    },
    highlight: {
      lightBlue: '#E3F2FD',
      darkBlue: '#1976D2',
      mediumBlue: '#2196F3',
      green: '#4CAF50',
      white: '#FFFFFF',
    },
    hotspot: {
      red: '#F44336',
      orange: '#ff9800',
      green: '#48bb78ff',
      gray: '#757575',
    },
    markdown: {
      textColor: '#E3E6EC',
    },
    pdfExport: {
      titleColor: '#E0E0E0',
      timestampColor: '#B0B0B0',
      backgroundColor: '#2D2D2D',
    },
    ticketStatus: {
      open: '#FFB74D',      // Lighter Orange for dark mode
      closed: '#66BB6A',    // Lighter Green for dark mode
      pending: '#42A5F5',   // Lighter Blue for dark mode
      default: '#BDBDBD',   // Lighter Grey for dark mode
    },
    latency: {
      veryFast: '#4CAF50',  // < 1s - green
      fast: '#2196F3',      // < 5s - blue
      medium: '#FF9800',    // < 10s - orange
      slow: '#FF5722',      // < 20s - deep orange
      verySlow: '#F44336',  // >= 20s - red
    },
    graph: {
      nodes: {
        start: {
          background: '#4CAF50',
          border: '#2E7D32',
          text: '#FFFFFF',
          shadow: '#4CAF504D', // 30% opacity
        },
        end: {
          background: '#EF5350',
          border: '#C62828',
          text: '#FFFFFF',
          shadow: '#EF53504D', // 30% opacity
        },
        process: {
          background: '#424242',
          border: '#616161',
          text: '#E3E6EC',
          shadow: '#00000066', // 40% opacity
        },
        selected: {
          background: '#2196F3',
          border: '#1565C0',
          text: '#FFFFFF',
          shadow: '#2196F366', // 40% opacity
        },
      },
      edges: {
        default: '#616161',
        highlighted: '#2196F3',
      },
      canvas: {
        light: '#FCFCFD',
        dark: '#151515',
      },
    },
    backgroundColor: '#080606ff',
    cardBackgroundColor: '#FCFCFC',
    textColor: '#f3f4f6',
  },
  typography: {
    allVariants: {
      fontFamily: "Proxima Nova, Arial, sans- serif"
    }
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: '#121212', // Dark background color for the entire page
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          backgroundImage: 'none',
          '&:before': {
            display: 'none',
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none', // or 'none', 'lowercase'
        },
      },
    },
  },
});